const STORAGE_KEY = 'volleyball_active_match';

export interface PersistedMatchRef {
  matchId: string;
  teamAId: string;
  teamBId: string;
  status: string;
  tournamentId?: string | null;
}

export function saveMatchRef(ref: PersistedMatchRef): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ref));
  } catch {
    // localStorage may be unavailable; fail silently
  }
}

export function loadMatchRef(): PersistedMatchRef | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as PersistedMatchRef;
  } catch {
    return null;
  }
}

export function clearMatchRef(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // fail silently
  }
}
